import { useEffect, useState } from "react";
import { StringUtils } from "../../../utils/StringUtils";
import { Link } from "react-router-dom";

import ErrorBoundary from "../../common/errorboundary";
import Heading from "../../common/text/heading";
import Grid from "../../common/grid";
import DisplayItem from "../../common/displayitem";
import { ExperienceProps } from "../../../interfaces/ExperienceProps";
import { EducationProps } from "../../../interfaces/EducationProps";
import { VolunteeringProps } from "../../../interfaces/VolunteeringProps";

const Background = () => {
    const [experienceData, setExperienceData] = useState<ExperienceProps[] | null>(null);
    const [experienceDataLoading, setExperienceDataLoading] = useState(true);
    const [educationData, setEducationData] = useState<EducationProps[] | null>(null);
    const [educationDataLoading, setEducationDataLoading] = useState(true);
    const [volunteeringData, setVolunteeringData] = useState<VolunteeringProps[] | null>(null);
    const [volunteeringDataLoading, setVolunteeringDataLoading] = useState(true);

    const retrieveExperience = async () => {
        await fetch(`/api/data/experience/featured-experience.json`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((data) => {
                setExperienceData(data);
                setExperienceDataLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                setExperienceDataLoading(false);
            });
    }

    const retrieveEducation = async () => {
        await fetch(`/api/data/education/featured-education.json`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((data) => {
                setEducationData(data);
                setEducationDataLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                setEducationDataLoading(false);
            });
    }

    const retrieveVolunteering = async () => {
        await fetch(`/api/data/volunteering/featured-volunteering.json`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((data) => {
                setVolunteeringData(data);
                setVolunteeringDataLoading(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                setVolunteeringDataLoading(false);
            });
    }

    useEffect(() => {
        retrieveExperience();
        retrieveEducation();
        retrieveVolunteering();
    }, []);

    return (
        <ErrorBoundary>
            <section data-testid="Background" className="background">
                <Heading variant="h2" className="background-title">
                    Background
                </Heading>

                <Grid columns={2}>
                    <Grid columns={1}>
                        <Heading variant="h3">
                            Experience
                        </Heading>

                        {experienceData && experienceData.map((experience, index) => {
                            return (
                                <DisplayItem
                                    key={index}
                                    type="background"
                                    title={experience.title}
                                    subtitle={StringUtils.createDateSubtitle(experience.organisation, experience.start_date, experience.end_date)}
                                    icon_id={experience.images?.icon_id}
                                    link={experience.shortcode ? `/experience/${experience.shortcode}` : undefined} />
                            )
                        })}
                        <Link to="/experience" className="link-exclude-accent">View all experience</Link>
                    </Grid>
                    <Grid columns={1}>
                        <Heading variant="h3">
                            Education
                        </Heading>

                        {educationData && educationData.map((education, index) => {
                            return (
                                <DisplayItem
                                    key={index}
                                    type="background"
                                    title={education.title}
                                    subtitle={StringUtils.createDateSubtitle(education.organisation, education.start_date, education.end_date)}
                                    icon_id={education.images?.icon_id}
                                    link={education.shortcode ? `/education/${education.shortcode}` : undefined} />
                            )
                        })}
                    </Grid>

                    <Grid columns={1}>
                        <Heading variant="h3">
                            Volunteering
                        </Heading>

                        {volunteeringData && volunteeringData.map((opportunity, index) => {
                            return (
                                <DisplayItem
                                    key={index}
                                    type="background"
                                    title={opportunity.title}
                                    subtitle={StringUtils.createDateSubtitle(opportunity.organisation, opportunity.start_date, opportunity.end_date)}
                                    icon_id={opportunity.images?.icon_id}
                                    link={opportunity.shortcode ? `/volunteering/${opportunity.shortcode}` : undefined} />
                            )
                        })}
                    </Grid>
                </Grid>
            </section>
        </ErrorBoundary>
    )
}

export default Background;